/* tslint:disable */
/* eslint-disable */
/**
 * AddOnSelector.Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProductTypeDto } from './ProductTypeDto';
import {
    ProductTypeDtoFromJSON,
    ProductTypeDtoFromJSONTyped,
    ProductTypeDtoToJSON,
} from './ProductTypeDto';

/**
 * 
 * @export
 * @interface RoomTypeDto
 */
export interface RoomTypeDto {
    /**
     * 
     * @type {number}
     * @memberof RoomTypeDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof RoomTypeDto
     */
    name: string;
    /**
     * 
     * @type {Array<ProductTypeDto>}
     * @memberof RoomTypeDto
     */
    readonly productTypes: Array<ProductTypeDto>;
}

/**
 * Check if a given object implements the RoomTypeDto interface.
 */
export function instanceOfRoomTypeDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "productTypes" in value;

    return isInstance;
}

export function RoomTypeDtoFromJSON(json: any): RoomTypeDto {
    return RoomTypeDtoFromJSONTyped(json, false);
}

export function RoomTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoomTypeDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'productTypes': ((json['productTypes'] as Array<any>).map(ProductTypeDtoFromJSON)),
    };
}

export function RoomTypeDtoToJSON(value?: RoomTypeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

